// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlocksSelectResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      included_count: number,
      created: objectOf({
        time: number,
        name: string,
        d_id: string,
        api_key_name: string,
      }),
      last_edited: objectOf({
        time: number,
        name: string,
        d_id: string,
        api_key_name: string,
      }),
      content_type: string,
    })
  ),
});
